<script>
import { mapActions } from 'vuex'
import StaticProcessor from '@lib/processors/static-processor'

export default {
  name: 'DashboardTop10Clicks',
  data() {
    return {
      requesting: true,
      table: {
        processor: null,
        columns: [
          {
            name: 'retailerName',
            label: 'Retailer',
            width: 150,
          },
          {
            name: 'offerName',
            label: 'Offer Name',
          },
          {
            name: '_count',
            label: 'Clicks',
            width: 60,
          },
        ],
        tableName: 'top-clicked-offers',
      },
    }
  },
  async created() {
    this.requesting = true
    const res = await this.getClicksNew({ dataType: 'top_ten_clicked_offers' })

    this.table.processor = new StaticProcessor({
      component: this,
      data: res,
    })
    this.requesting = false
  },
  methods: {
    ...mapActions('dashboard', ['getClicksNew']),
  },
}
</script>

<template>
  <el-card body-style="padding-top: 0; padding-bottom: 0">
    <div slot="header">
      Top 10 Offers Clicked
    </div>
    <base-loader
      v-if="requesting"
      :class="$style.loader"
    />
    <table-layout
      v-else
      :table-name="table.name"
      :processor="table.processor"
      :columns="table.columns"
      :table-controls="false"
      :class="$style.offersTable"
      :multisort="false"
      shadow="never"
    />
  </el-card>
</template>

<style lang="scss" module>
.loader {
  margin-bottom: 2rem
}

.offersTable {
  border: none !important;

  :global {
    .el-card__body, .el-card__body > div {
      padding: 0;
    }
  }
}
</style>
